const mui = {
  MuiButton: {
    styleOverrides: {
      root: ({ theme }) => ({
        boxShadow: theme.shadows[0],
        fontSize: "14px",
        padding: "0.5rem 1rem",
        minWidth: "100px",
        color: theme.palette.grey[800],
        backgroundColor: theme.palette.primary.light,
        "&:hover": {
          boxShadow: theme.shadows[0],
          color: theme.palette.grey[700],
          borderColor: theme.palette.primary.dark,
          backgroundColor: theme.palette.primary.light,
        },
        "&.Mui-disabled": {
          color: theme.palette.grey[500],
          backgroundColor: theme.palette.grey[700],
        },
      }),
    },
  },
};
export default mui;
